import BaseExtendedListViewController from '../../base/controllers/extended-list-view';
import moment from 'moment';
import oktoberfestOverviewTemplate from '../views/custom-overviews/oktoberfest.tpl.html';
import askToArchiveContact from "../../../modules/contacts/helpers/ask-to-archive-contact";
import contactSingleMessageModalCreator from '../../../modules/messages/helpers/contact-single-message-modal-creator';

export default class ContactCardCtrl extends BaseExtendedListViewController {
    constructor(model, $injector, $scope) {
        super(model, $injector, $scope);
        this.params = $injector.get('$stateParams');
        this.modal = $injector.get('$uibModal');
        this.sanitize = $injector.get('$sanitize');
        this.rootScope = $injector.get('$rootScope');
        this.parameters = {
            include: 'latestMessage,latestRsvp,latestRsvp.guestlist,picklists,categories'
        };
        this.availableViews = [
            {
                key: 'overview',
                label: 'Overview'
            },
            {
                key: 'bookings',
                label: 'Bookings'
            },
            {
                key: 'messages',
                label: 'Messages'
            }
        ];
        this.latestChangeInformation = null;

        this.setupContactSpecialViews();
        this.initWatcher();
    }

    $onInit() {
        this.delete = _.includes(this.scope.vm.store.getters.slug, 'picklist') ? this.confirmNRemove : this.confirmNDelete;
    }

    initWatcher() {
        this.scope.$watch(() => {
            return this.store.state.data;
        }, () => {
            if (!this.loading) {
                this.loadData()
            }
        });
    }

    loadData() {
        return super.loadData().then(() => {
            this.contact = this.model;
            this.latestChangeInformation = this._prepareLatestChangeInformation(this.model.last_change);
        });
    }

    openContactDetails() {
        return this.state.go('app.contacts.details.overview', {
            id: this.model.id,
            contact: this.model,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    editContact() {
        return this.state.go('app.contacts.edit', {
            id: this.model.id,
            contact: this.model,
            skipReload: true,
            store: this.store,
            back: this.state.current.name,
            backParams: this.params
        });
    }

    sendEmail() {
        contactSingleMessageModalCreator(this.injector, this.model);
    }

    confirmNRemove() {
        // @todo new alert - don't
        this.alert.confirm({
            title: 'Confirm Removal From Picklist',
            message: `Please confirm you want to remove ${this.model.full_name || this.model.first_name + ' ' + this.model.last_name} from this picklist?`,
            type: 'warning',
            confirmBtn: 'Remove',
            wait: true,
        }).then(() => {
            this.api.delete('picklists/contacts', {
                data: {
                    picklists: {
                        count: 1,
                        filters: [
                            {
                                field: 'id',
                                operator: 'IN',
                                value: [this.params.pid]
                            }
                        ]
                    },
                    contacts: {
                        count: 1,
                        filters: [
                            {
                                field: 'id',
                                operator: 'IN',
                                value: [this.model.id]
                            }
                        ]
                    },
                }
            }).then(() => {
                if (this.store) {
                    this.store.dispatch('getData');
                }
                this.alert.hide();
                return this.alert.success('Success', `Moved ${this.model.full_name} to trash`);
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }

    confirmNDelete() {

        askToArchiveContact(this.model, this.injector).then(
            () => {
                if (this.store) {
                    this.store.dispatch('getData');
                }
            }
        );
    }

    setupContactSpecialViews() {
        this.contactSpecialViews = {

        };
        this.specialContactView = null;

        const settingSpecialView = _.get(this.rootScope.user, 'company.data.settings.companies.special_views.contact-preview');
        if (settingSpecialView
            && Object.keys(this.contactSpecialViews).indexOf(settingSpecialView) !== -1) {
            this.specialContactView = this.contactSpecialViews[settingSpecialView];
        }

        this.specialOverviews = {
            'oktoberfest': oktoberfestOverviewTemplate
        };
        this.specialContactOverview = null;

        const settingSpecialOverview = _.get(this.rootScope.user, 'company.data.settings.companies.special_views.contact-preview-overview');
        if (settingSpecialOverview
            && Object.keys(this.specialOverviews).indexOf(settingSpecialOverview) !== -1) {
            this.specialContactOverview = this.specialOverviews[settingSpecialOverview];
        }
    }

    _prepareLatestChangeInformation(latestChange) {
        if (!latestChange) {
            return null;
        }

        let out = null;
        const firstField = latestChange.fields[_.first(Object.keys(latestChange.fields))];

        if (firstField) {
            out = {
                timestamp: latestChange.timestamp,
                firstField: {
                    label: firstField.label,
                    mode: firstField.mode,
                    values: this._prepareChangeValuesForType(firstField.values, firstField.type)
                },
                moreChangesCount: Object.keys(latestChange.fields).length - 1
            };
        }

        return out;
    }


    _prepareChangeValuesForType(values, type) {
        const out = {};

        _.each(values, (originalValue, key) => {
            let value;
            switch (type) {
                case 'bool':
                    value = originalValue ? this.translate.instant('general.verbs.yes') : this.translate.instant('general.verbs.no');
                    break;
                case 'date':
                    value = moment(originalValue).format('D.M.Y');
                    break;
                case 'datetime':
                    value = moment(originalValue).format('Y-M-D HH:mm:ss');
                    break;
                case 'string':
                    value = this.sanitize(originalValue + '');
                    break;
                case 'integer':
                    value = parseInt(originalValue);
                    break;
                case 'float':
                    value = parseFloat(originalValue);
                    break;
                default:
                    console.info('No transformer for type "' + type + '" defined');
                    value = this.sanitize(originalValue);
            }

            out[key] = value;
        });

        return out;
    }

    goToChangelog() {
        this.state.go('app.contacts.details.changelog', {
            id: this.contact.id,
            store: this.store,
            contact: this.contact
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/store/contacts/controllers/extended-list-view.js